<section class="report-catalog" aria-labelledby="catalog-title">
  <div class="section-title">
    <div>
      <span class="section-kicker">Catálogo</span>
      <h2 id="catalog-title">Relatórios disponíveis</h2>
      <p>Escolha o documento que pretende consultar ou gerar.</p>
    </div>
    <span class="count-badge">
      @if (loading) {
        A carregar…
      } @else {
        {{ reports.length }} {{ reports.length === 1 ? 'modelo' : 'modelos' }}
      }
    </span>
  </div>

  @if (loading) {
    <div class="catalog-state loading-state" role="status" aria-live="polite">
      <div class="catalog-state-content">
        <span class="catalog-state-icon"><i class="pi pi-spinner pi-spin"></i></span>
        <h3>A carregar catálogo</h3>
        <p>Estamos a consultar os relatórios disponíveis para este tenant.</p>
      </div>
    </div>
  } @else if (loadFailed) {
    <div class="catalog-state error-state" role="alert">
      <div class="catalog-state-content">
        <span class="catalog-state-icon"><i class="pi pi-cloud-times"></i></span>
        <span class="state-eyebrow">Ligação indisponível</span>
        <h3>Não foi possível carregar os relatórios</h3>
        <p>O catálogo não pôde ser consultado. Verifique a ligação e tente novamente.</p>
        <button type="button" class="btn btn-primary" (click)="retryRequested.emit()">
          <i class="pi pi-refresh"></i>
          Tentar novamente
        </button>
      </div>
    </div>
  } @else if (reports.length === 0) {
    <div class="catalog-state empty-state">
      <div class="catalog-state-content">
        <span class="catalog-state-icon"><i class="pi pi-file-plus"></i></span>
        <span class="state-eyebrow">Catálogo vazio</span>
        <h3>Nenhum relatório activo</h3>
        <p>Este tenant ainda não possui modelos de relatório configurados. Active os modelos necessários nas configurações da aplicação.</p>
        <div class="catalog-state-actions">
          <a class="btn btn-primary" routerLink="/admin/configuracoes">
            <i class="pi pi-cog"></i>
            Configurar relatórios
          </a>
        </div>
        <span class="state-hint">
          <i class="pi pi-info-circle"></i>
          Apenas os modelos activos serão apresentados nesta página.
        </span>
      </div>
    </div>
  } @else {
    <div class="report-grid">
      @for (report of reports; track report.id) {
        <article class="report-card" [class.locked]="!report.available">
          <div class="card-main">
            <div class="card-top">
              <div class="card-icon" [ngClass]="report.color">
                <i [class]="report.icon"></i>
              </div>

              <div class="card-heading">
                <h3>{{ report.title }}</h3>
                @if (report.available) {
                  <div class="chips">
                    @for (format of report.formats; track format) {
                      <span>{{ format }}</span>
                    }
                  </div>
                } @else {
                  <span class="development-chip">Em desenvolvimento</span>
                }
              </div>
            </div>

            <p class="description">{{ report.description }}</p>

            @if (!report.available) {
              <div class="development-state">
                <i class="pi pi-lock"></i>
                <span>Este relatório estará disponível brevemente.</span>
              </div>
            }
          </div>

          @if (report.available) {
            <div class="card-actions">
              <button type="button" class="btn btn-ghost"
                (click)="previewRequested.emit(report.id)" [disabled]="generating">
                <i class="pi pi-eye"></i>
                Pré-visualizar
              </button>
              <button type="button" class="btn btn-primary"
                (click)="configureRequested.emit(report.id)" [disabled]="generating">
                <i class="pi pi-sliders-h"></i>
                Configurar
              </button>
            </div>
          }
        </article>
      }
    </div>
  }
</section>